import React, { useState, useEffect, useMemo } from 'react';
import { Box, Typography, Container, Link, Button, TextField } from '@mui/material';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import api, { API_BASE_URL } from './api';
import Header from './components/Header';
import { useConfirmBackLogout } from './common/useConfirmBackLogout';
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import HamburgerMenu from './components/Hamburger.jsx';
import { validateSelectedFiles } from "./common/fileUploadValidation.js";

const NoticeDetail = () => {
  const { noticeId } = useParams();
  const [notice, setNotice] = useState(null);
  const [role, setRole] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const [showFormMenu, setShowFormMenu] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editTitle, setEditTitle] = useState('');
  const [editBody, setEditBody] = useState('');
  const [editDate, setEditDate] = useState('');
  const [editFile, setEditFile] = useState(null);
  const [noticeCategory, setNoticeCategory] = useState('お知らせ');
  const [visibilitySetting, setVisibilitySetting] = useState('全体');

  const handleEditFileChange = (e) => {
    const validation = validateSelectedFiles(e.target.files);
    if (!validation.valid) {
      alert(validation.message);
      e.target.value = null;
      return;
    }
    setEditFile(validation.files[0] || null);
  };

  useEffect(() => {
    api.get('/api/auth/me').then((res) => setRole(res.data?.role || 'guest')).catch(() => setRole('guest'));

    // お知らせデータ取得もこっちにまとめる
    api.get(`/api/notices/${noticeId}`)
      .then(res => setNotice(res.data))
      .catch(err => {
        console.error('お知らせ取得失敗:', err);
        setNotice(null);
      });
  }, [noticeId]);

  const handleLogout = () => {
    localStorage.removeItem('user');
    sessionStorage.clear(); // ← これ追加！
    navigate('/');
  };

  const handleSave = async () => {
    const formData = new FormData();
    formData.append("title", editTitle);
    formData.append("body", editBody);
    formData.append("date", editDate);
    formData.append("category", noticeCategory); // ← 追加
    formData.append("visibility_setting", visibilitySetting); // ← 追加

    if (editFile) {
      formData.append("file", editFile);
    }

    try {
      await api.put(`/api/notices/${noticeId}/update`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("保存しました");
      setEditMode(false);
      // 必要に応じて再取得や画面遷移
    } catch (error) {
      console.error("保存エラー:", error);
      alert("保存に失敗しました");
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("本当に削除しますか？")) return;

    try {
      await api.delete(`/api/notices/${noticeId}`);
      alert("削除しました");
      setTimeout(() => {
        navigate(`/create-notice`);
      }, 1000);
    } catch (err) {
      console.error("削除失敗:", err);
      alert("削除に失敗しました");
    }
  };

  let topPath = '/';
    switch (role) {
    case 'host':
        topPath = '/host-dashboard';
        break;
    case 'exhibitor':
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const mypage = user?.mypage_url || '';
        topPath = `/${mypage}`; // バッククォートで動的文字列
        break;
    case 'corporate':
        topPath =  `/${mypage}`;
        break;
    default:
        topPath = '/';
    }

  const [isHovered, setIsHovered] = useState(false);
  
    const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展規定', path: '/出展規定.pdf' },
      { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
      { label: '色見本', path: '/色見本.pdf' },
      { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
      { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
      { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者用追加パス', path: '/出展者用追加パス.pdf' },
      { label: '小間図面', path: '/小間図面.pdf' },
      { label: '素材集', path: '/素材集.zip' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];
  
    const renderMenuItems = () => (
        <div
            className="menu-item"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className="menu-label">資料ダウンロード</div>
            {isHovered && (
            <div className="submenu">
                {pdfItems.map((item, index) => (
                <a key={index} href={item.path} download className="submenu-item">
                    {item.label}
                </a>
                ))}
            </div>
            )}
        </div>
    );

const handleScrollTo = (id, targetUrl) => {
    if (targetUrl && window.location.pathname !== targetUrl) {
      // 別ページなら localStorage に保存して navigate
      localStorage.setItem('scrollToId', id);
      navigate(targetUrl);
    } else {
      // 同ページなら即スクロール
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  const renderSideMenu = () => {
    switch (role) {
      case 'host':
        return (
          <>
            <Box className="menu-item" onClick={() => navigate('/host-dashboard')}>
              申請状況
            </Box>
            <Box
              className="menu-group"
              id="hover-block"
              onMouseEnter={() => {}}
              onMouseLeave={() => {}}
            >
              <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                会社情報
              </Box>
                {showFormMenu && (
                  <Box className="hover-menu">
                    <Typography
                      sx={{ color: '#0071bc', textAlign: 'center' }}
                      className='form-button'
                      onClick={() => navigate('/exhibitor-info')}
                    >
                      出展者
                    </Typography>
                    <Typography
                      sx={{ color: '#0071bc', textAlign: 'center' }}
                      className='form-button'
                      onClick={() => navigate('/corporate-info')}
                    >
                      協力会社
                    </Typography>
                  </Box>
                )}
            </Box>
            <Box className="menu-item" onClick={() => navigate('/create-mail')}>
              メール作成
            </Box>
            <Box className="menu-item" onClick={() => navigate('/create-notice')}>
              お知らせ作成
            </Box>
            <Box className="menu-item" onClick={() => navigate('/form-history')}>
              再提出ログ確認
            </Box>
          </>
        );
      case 'exhibitor':
        return (
          <>
              <style>
              {`
              @media only screen and (max-width: 560px) {
              .sm-block {display: block;}
              .sm-none {display: none;}
              .sm-column {flex-direction: column;}
              .noti-cate {font-size: 18px;}
              .timestamp {font-size: 14px;}
              .info {font-size: 14px;}
              .f-16 {font-size: 16px;}
              .sm-w-100 {width : 100%;}
              }
              @media only screen and (min-width: 561px) {
              .hamburger_menu_btn_wrap {display: none;}
              .sm-w-100 {width: 80%;}
              }
              `}
            </style>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }} className="sm-none">
              <Box
                    className={`menu-item`}
                    onClick={() => {
                    const user = JSON.parse(localStorage.getItem('user'));
                    navigate(`${user?.mypage_url}`);
                    }}
                >
                    TOP
                </Box>
                <Box 
                    className="menu-item"
                    onClick={() => {
                    const user = JSON.parse(localStorage.getItem('user'));
                    navigate(`/mypage-info/${user?.exhibitor_id}`);
                    }}
                >
                    出展者情報編集
                </Box>
                <Box 
                    className="menu-item"
                    onClick={() => {
                    navigate('/mail-form/');
                    }}
                >
                    お問い合わせ
                </Box>
                {renderMenuItems()}
                <Box 
                    className="menu-item"
                    onClick={() => {
                    const user = JSON.parse(localStorage.getItem('user') || '{}');
                    const mypage = user?.mypage_url;
    
                    handleScrollTo('news', mypage);
                    }}
                >
                    お知らせ
                </Box>
                <Box
                  className="menu-item"
                  onClick={() => window.open('https://www.messenagoya.jp/policy/privacy', '_blank', 'noopener,noreferrer')}
                >
                  個人情報保護方針
                </Box>
            </Box>
          </>
        );
      case 'corporate':
        return (
          <>
            <Box
            className="menu-item"
            onClick={() => {
            const user = JSON.parse(localStorage.getItem('user'));
            const mypage = user?.mypage_url;
            navigate(mypage);
            }}
            >
            TOP
            </Box>
            <Box
            className="menu-item"
            onClick={() => {
            const user = JSON.parse(localStorage.getItem('user'));
            const repId = user?.representative_id;
            navigate(`/corporate-mypage-info/${repId}`);
            }}
            >
            協力会社情報編集
            </Box>
            <Box 
            className="menu-item"
            onClick={() => {
                navigate('/mail-form/');
            }}
            >
            お問い合わせ
            </Box>
            <Box 
            className="menu-item"
            onClick={() => {
                const user = JSON.parse(localStorage.getItem('user') || '{}');
                const mypage = user?.mypage_url;

                handleScrollTo('news', mypage);
            }}
            >
            お知らせ
            </Box>
          </>
        );
      default:
        return null;
    }
  };

  const renderMainContent = () => {
    if (!notice) {
      return <Typography variant="h6">お知らせが見つかりませんでした。</Typography>;
    }

    return (
      <>
        {editMode ? (
          <>
            <TextField
              label="タイトル"
              fullWidth
              value={editTitle}
              onChange={(e) => setEditTitle(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              label="本文"
              fullWidth
              multiline
              rows={6}
              value={editBody}
              onChange={(e) => setEditBody(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              label="日付"
              type="date"
              value={editDate}
              onChange={(e) => setEditDate(e.target.value)}
              sx={{ mb: 2 }}
              InputLabelProps={{ shrink: true }}
            />
            <Typography variant="subtitle1" sx={{ mt: 2 }}>カテゴリー</Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              {['お知らせ', '重要', '緊急'].map((cat) => (
                <label key={cat}>
                  <input
                    type="radio"
                    value={cat}
                    checked={noticeCategory === cat}
                    onChange={(e) => setNoticeCategory(e.target.value)}
                  />
                  {cat}
                </label>
              ))}
            </Box>

            <Typography variant="subtitle1" sx={{ mt: 2 }}>表示対象</Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              {['全体', '出展者', '協力会社'].map((v) => (
                <label key={v}>
                  <input
                    type="radio"
                    value={v}
                    checked={visibilitySetting === v}
                    onChange={(e) => setVisibilitySetting(e.target.value)}
                  />
                  {v}
                </label>
              ))}
            </Box>
            <Box sx={{ mt: 2 }}>
              <Button variant="outlined" component="label">
                添付ファイルを選択
                <input
                  type="file"
                  hidden
                  onChange={handleEditFileChange}
                />
              </Button>
              {editFile && <Typography>{editFile.name}</Typography>}
              <Typography variant="body2">※ファイルサイズは10MBまでです。</Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Button variant="contained" onClick={handleSave}>保存</Button>
              <Button sx={{ ml: 2 }} onClick={() => setEditMode(false)}>キャンセル</Button>
            </Box>
          </>
        ) : (
          <>
            <Typography variant="h4">{notice.title}</Typography>
            <Typography variant="subtitle2" color="text.secondary">{notice.date}</Typography>
            <Typography variant="body1" sx={{ mt: 2, whiteSpace: 'pre-wrap' }}>{notice.body}</Typography>
            {notice.file_path && (
              <Box sx={{ mt: 3 }}>
                <Typography variant="subtitle1">添付ファイル:</Typography>
                <Link
                  href={`/api/uploaded_files/${notice.file_path.split('/').pop()}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {notice.file_path.split('/').pop()}
                </Link>
              </Box>
            )}
          </>
        )}

        {/* 主催者なら編集ボタンも表示 */}
        {role === 'host' && (
          <Box sx={{ mt: 3 }}>
            <Button variant="contained" onClick={() => {
              setEditMode(true);
              setEditTitle(notice.title);
              setEditBody(notice.body);
              setEditDate(notice.date);
            }}>
              編集する
            </Button>
            <Button variant="outlined" color="error" onClick={handleDelete}>削除する</Button>
          </Box>
        )}
        {role === 'exhibitor' && (
          <HamburgerMenu />
        )}
      </>
    );
  };

  return (
    <div>
      <Header
        title="SDGs子ども・ユースフェア お知らせ詳細"
      />
      <BackButton />
      <Container sx={{ mt: 5 }}>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ width: '22%', mt: 4, px: '24px' }} className="sm-none">
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {renderSideMenu()}
            </Box>
          </Box>

          <Box sx={{ width: '80%', mt: 4 , px: '24px'}} className="sm-w-100">
            {renderMainContent()}
          </Box>
        </Box>
      </Container>
    </div>
  );
};

export default NoticeDetail;
